

const setColor=(color)=>{
    if (color === "error") {
        return "#ed3237"
    } else if (color === "success") {
        return "#6af042"
    } else if (color === "warning") {
        return "#f0ad42"
    } else if (color === "info") {
        return "#42b5f0"
    }
};

export default setColor